import moment from 'moment';
import {IOptions, ITimeGridHourLabel} from 'tui-calendar';

interface CalendarConfigType {
    scrollToHour: number; // the hour the browser will scroll to automatically
    businessDayStartHour: number; // hours before will be grey
    businessDayEndHour: number; // hours after will be grey
    businessDayDurationHours: number; // hours a person will work per day
    calendarOptions: IOptions; // hours after will be grey
}

const DEFAULT_CALENDAR_CONFIG: CalendarConfigType = {
    scrollToHour: 7,
    businessDayStartHour: 8,
    businessDayEndHour: 17,
    businessDayDurationHours: 8,
    calendarOptions: {
        defaultView: 'day',
        taskView: false,
        usageStatistics: false,
        isReadOnly: true,
        scheduleView: ['time'],
        week: {
            daynames: [
                moment.weekdays(0), // monday as Montag
                moment.weekdays(1), // tuesday as Dienstag
                moment.weekdays(2), // ...
                moment.weekdays(3),
                moment.weekdays(4),
                moment.weekdays(5),
                moment.weekdays(6),
            ]
        },
        template: {
            timegridDisplayPrimayTime: (time: ITimeGridHourLabel) => {
                // label at the right of the time grid
                return time.hour + ' Uhr';
            }
        }
    }
};

export {DEFAULT_CALENDAR_CONFIG};
